import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateUserDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_USERS } from "../domain";

import { usersApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_USER = "CREATE_USER";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const createUser = async (data: CreateUserDto): Promise<void> => {
  const response = await usersApi.usersControllerCreateUser(data);

  return response.data;
};

export const useCreateUser = (
  user: UserProfileDto | null,
): {
  createUser: (data: CreateUserDto) => void;
  createUserAsync: (data: CreateUserDto) => Promise<void>;
  createUserEnabled: boolean;
  createUserError: Error | null;
  isSuccessCreateUser: boolean;
  isPendingCreateUser: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending, error } = useMutation({
    mutationKey: [DOMAIN_USERS, ACTION_CREATE_USER],
    mutationFn: enabled ? createUser : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_USERS] });
    },
  });

  return {
    createUser: mutate,
    createUserAsync: mutateAsync,
    createUserEnabled: enabled,
    createUserError: error,
    isSuccessCreateUser: isSuccess,
    isPendingCreateUser: isPending,
  };
};
